// BANEO — before / after comparison slider (sections/baneo-before-after-slider.liquid).
(function () {
  function init(root) {
    root.querySelectorAll('[data-baneo-ba]').forEach((stage) => {
      const range = stage.querySelector('.baneo-ba__range');
      if (!range || range.dataset.bound) return;
      range.dataset.bound = 'true';
      const update = () => stage.style.setProperty('--baneo-ba-pos', range.value + '%');
      range.addEventListener('input', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
